
import { defineComponent, onMounted, onUnmounted, ref, watch } from 'vue';
import { calculateWindowSize } from '@/common/utils/helpers';
import { useUiStore } from '@/modules/ui/store';
import { Tooltip } from 'admin-lte/plugins/bootstrap/js/bootstrap.min.js';

export default defineComponent({
    name: 'App',
    setup() {
        const uiStore = useUiStore();
        const windowSize = ref(calculateWindowSize(window.innerWidth));
        let globalTooltip: any = null;

        function resize() {
            windowSize.value = calculateWindowSize(window.innerWidth);
        }

        function tooltipMouseOver(event: MouseEvent) {
            const target = (event.target as HTMLElement).closest('[data-toggle="tooltip"]');
            if (target && !globalTooltip) {
                globalTooltip = new Tooltip(target, { trigger: 'hover' });
                globalTooltip.show();
            }
        }

        function tooltipMouseOut() {
            if (globalTooltip) {
                globalTooltip.hide();
                globalTooltip.dispose();
                globalTooltip = null;
            }
        }

        onMounted(() => {
            window.addEventListener('resize', resize);
            document.addEventListener('mouseover', tooltipMouseOver);
            document.addEventListener('mouseout', tooltipMouseOut);
            document.addEventListener('focusout', tooltipMouseOut);
        });

        onUnmounted(() => {
            window.removeEventListener('resize', resize);
            document.removeEventListener('mouseover', tooltipMouseOver);
            document.removeEventListener('mouseout', tooltipMouseOut);
            document.removeEventListener('focusout', tooltipMouseOut);
        });

        watch(windowSize, value => uiStore.setScreenSize(value));

        return {};
    }
});
